import { transitionDurations } from "@huub-web/ui";
import type { MotionProps } from "motion/react";

export const templatesScreenChildMotionProps: MotionProps = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: transitionDurations.m,
      delay: transitionDurations.s,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: transitionDurations.m,
    },
  },
};

export const templatesScreenGrandChildMotionProps: MotionProps = {
  initial: {
    // x: 10,
  },
  animate: {
    // x: 0,
  },
  exit: {
    // x: -10,
  },
};
